<p-dialog
  [header]="'KardexAudit_RollHistory' | translateWF: 'Roll History: ' + rollNumber"
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [style]="{ width: '90vw', maxWidth: '1200px' }"
  [maximizable]="true"
  [draggable]="false"
  appendTo="body"
>
  @if (isLoading()) {
    <div class="row-center-stretch py-8">
      <p-progressSpinner strokeWidth="4" />
    </div>
  } @else {
    <p-table [value]="transactions()" [rowHover]="true" [paginator]="transactions().length > 25" [rows]="25">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'KardexAudit_TxId' | translateWF: 'Tx ID' }}</th>
          <th>{{ 'KardexAudit_Date' | translateWF: 'Date' }}</th>
          <th>{{ 'KardexAudit_Movement' | translateWF: 'Movement' }}</th>
          <th>{{ 'KardexAudit_Document' | translateWF: 'Document #' }}</th>
          <th>{{ 'KardexAudit_DocType' | translateWF: 'Doc Type' }}</th>
          <th>{{ 'KardexAudit_ProductionCard' | translateWF: 'Production Card' }}</th>
          <th>{{ 'KardexAudit_TransferUnit' | translateWF: 'Transfer Unit' }}</th>
          <th>{{ 'KardexAudit_Qty' | translateWF: 'Qty' }}</th>
          <th>{{ 'KardexAudit_From' | translateWF: 'From' }}</th>
          <th>{{ 'KardexAudit_To' | translateWF: 'To' }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-tx>
        <tr [class.bg-yellow-50]="tx.transactionId === highlightTransactionId">
          <td>
            <span class="cursor-pointer font-mono text-sm" [pTooltip]="tx.transactionId" tooltipPosition="top" (click)="copyToClipboard(tx.transactionId)">
              {{ shortId(tx.transactionId) }}
              <i class="pi pi-copy text-xs ml-1 text-color-secondary"></i>
            </span>
          </td>
          <td>{{ tx.movementDate | hnDate: 'MM/dd/yyyy HH:mm' }}</td>
          <td>{{ tx.movementDescription }}</td>
          <td>{{ tx.documentNumber }}</td>
          <td>{{ tx.documentType }}</td>
          <td>{{ tx.productionCardNumber || '—' }}</td>
          <td>{{ tx.transferUnitNumber || '—' }}</td>
          <td>{{ tx.quantity | number: '1.2-2' }}</td>
          <td>{{ (tx.fromLocationName | localized) || tx.fromLocationCode || '—' }}</td>
          <td>{{ (tx.toLocationName | localized) || tx.toLocationCode || '—' }}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="10" class="text-center py-8">
            {{ 'KardexAudit_NoTransactionsForRoll' | translateWF: 'No transactions found for this roll' }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</p-dialog>
